export function isDurstMachine(machine?: { name?: string } | null): boolean {
    return Boolean(machine?.name?.includes('Durst'))
}
